var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigTomatoStarBurst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 996,
    height: 713,
    viewBox: "0 0 996 713",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.324 0.351562L576.805 247.859H863.135L631.489 400.828L719.97 648.335L488.324 495.367L256.678 648.335L345.159 400.828L113.513 247.859H399.843L488.324 0.351562Z",
    fill: "#F8B551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M764.518 103.036L636.785 335.951L841.032 518.339L557.842 479.9L430.11 712.815L382.821 456.143L99.6318 417.704L353.596 297.512L306.307 40.8401L510.554 223.229L764.518 103.036Z",
    fill: "#F8B551"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M631.023 24.6609L614.896 284.493L881.797 378.725L604.93 445.078L588.803 704.91L433.816 486.086L156.949 552.439L338.029 350.845L183.042 132.021L449.943 226.254L631.023 24.6609Z",
    fill: "#F8B551"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793.801 603.811L808.051 584.543L820.52 603.811L808.051 621.282L793.801 603.811Z",
    fill: "#F8B551"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0253906 253.128L14.2755 233.859L26.7443 253.128L14.2755 270.598L0.0253906 253.128Z",
    fill: "#F8B551"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6543 482.468L108.904 463.199L121.373 482.468L108.904 499.938L94.6543 482.468Z",
    fill: "#F8B551"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.209 79.456L222.459 60.1875L234.928 79.456L222.459 96.9261L208.209 79.456Z",
    fill: "#F8B551"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959.682 365.569L973.932 346.301L986.401 365.569L973.932 383.039L959.682 365.569Z",
    fill: "#F8B551"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1280_10456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M793.801 175.198L808.051 155.93L820.52 175.198L808.051 192.668L793.801 175.198Z",
    fill: "#F8B551"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M441.633 395.545C441.633 395.545 444.826 371.178 439.019 360.161C433.212 349.145 415.287 324.815 378.111 320.428C358.394 318.112 345.043 320.726 332.869 322.164C325.158 323.079 310.799 318.336 285.013 324.199C265.893 328.55 236.877 345.373 227.448 381.634C222.481 400.735 224.367 421.368 232.825 438.751C249.07 472.099 279.225 480.221 279.225 480.221L339.834 485.151L413.214 454.118L441.633 395.545V395.545Z",
    fill: "#FF2A23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M371.165 488.345C409.741 480.801 443.089 446.296 448.896 409.755C454.329 375.567 434.351 352.656 434.351 352.656C434.351 352.656 436.629 370.899 432.371 390.336C427.797 411.137 414.558 445.81 372.621 465.453C321.143 489.558 264.754 473.669 264.754 473.669C264.754 473.669 303.069 501.658 371.165 488.345V488.345Z",
    fill: "#DC0D27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.529 364.514C254.279 361.862 241.488 369.611 239.64 392.297C237.941 413.079 249.2 438.118 260.235 435.131C269.608 432.591 260.59 415.226 263.932 400.98C267.311 386.733 280.158 368.565 264.529 364.514V364.514Z",
    fill: "#FED3B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.507 351.982C276.05 353.868 279.43 362.159 296.589 362.047C313.73 361.935 316.605 356.762 324.242 359.078C331.879 361.393 337.835 370.58 346.275 375.602C358.076 382.623 375.104 380.831 374.992 377.712C374.88 374.575 370.717 376.181 367.132 371.793C363.547 367.387 357.198 355.754 357.198 355.754C357.198 355.754 358.972 350.302 362.725 350.507C371.389 350.974 381.023 349.256 386.326 345.933C392.675 341.974 395.065 335.869 393.907 334.468C392.749 333.087 389.146 336.821 387.185 336.466C385.225 336.111 372.472 336.354 372.472 336.354L357.067 333.852C357.067 333.852 359.177 324.834 363.341 320.203C367.505 315.572 374.04 309.205 373.909 308.402C373.779 307.599 368.532 308.309 368.532 308.309L352.306 315.722L340.954 330.659L319.406 333.441L298.662 319.531C298.662 319.531 286.768 309.933 286.226 310.157C283.22 311.39 287.795 315.964 291.249 321.491C294.237 326.29 294.853 328.699 298.886 332.041C302.826 335.29 309.435 338.52 309.435 338.52L304.693 347.09C304.693 347.09 289.401 353.121 286.73 353.121C284.079 353.14 278.309 350.955 277.507 351.982V351.982Z",
    fill: "#BDCF44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M325.382 346.812C331.637 347.279 336.156 355.588 341.795 361.245C350.029 369.48 356.471 373.774 363.398 375.399C366.871 376.202 374.844 377.527 374.844 377.527C374.844 377.527 376.002 376.724 372.062 374.521C368.122 372.318 365.751 368.098 365.172 366.137C364.593 364.177 362.782 357.735 358.973 352.395C355.164 347.055 350.832 344.795 352.214 342.368C353.595 339.941 365.545 344.049 377.047 342.2C392.227 339.773 394.543 334.899 393.852 334.32C393.161 333.742 383.769 336.524 379.026 335.478C374.284 334.433 370.213 331.184 363.043 331.184C358.151 331.184 353.371 332.957 352.083 330.287C351 328.047 355.07 320.559 358.17 317.74C365.695 310.906 373.817 309.282 373.817 308.348C373.817 306.425 360.616 305.342 351.467 312.642C342.355 319.906 344.073 329.447 332.235 329.447C328.295 329.447 326.783 328.514 326.783 328.514C326.783 328.514 321.498 324.163 314.44 320.335C307.382 316.508 302.061 318.207 297.99 316.246C293.939 314.286 286.75 309.207 286.059 310.234C285.368 311.261 291.455 318.207 299.111 323.883C306.766 329.559 315.337 332.453 312.891 334.769C310.463 337.084 306.411 338.596 302.584 341.49C298.756 344.385 295.395 348.548 290.764 350.061C286.134 351.573 278.516 350.509 277.47 351.779C276.424 353.048 285.536 357.436 299.783 354.785C313.992 352.133 314.03 345.972 325.382 346.812V346.812Z",
    fill: "#94A61D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M339.592 275.225C336.473 275.076 332.534 277.541 332.534 277.541C332.534 277.541 326.82 284.505 324.561 301.795C323.515 309.787 324.654 320.523 324.43 326.442C324.206 332.343 322.918 334.546 323.272 337.571C323.627 340.577 326.783 343.975 334.083 343.9C339.946 343.844 342.971 339.307 342.859 337.683C342.747 336.058 337.724 319.496 339.143 304.895C340.469 291.32 345.417 281.947 345.623 279.987C345.735 278.922 344.334 275.449 339.592 275.225V275.225Z",
    fill: "#728035"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M700.633 432.545C700.633 432.545 703.826 408.178 698.019 397.161C692.212 386.145 674.287 361.815 637.111 357.428C617.394 355.112 604.043 357.726 591.869 359.164C584.158 360.079 569.799 355.336 544.013 361.199C524.893 365.55 495.877 382.373 486.448 418.634C481.481 437.735 483.367 458.368 491.825 475.751C508.07 509.099 538.225 517.221 538.225 517.221L598.834 522.151L672.214 491.118L700.633 432.545V432.545Z",
    fill: "#FF2A23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M630.165 525.345C668.741 517.801 702.089 483.296 707.896 446.755C713.329 412.567 693.351 389.656 693.351 389.656C693.351 389.656 695.629 407.899 691.371 427.336C686.797 448.137 673.558 482.81 631.621 502.453C580.143 526.558 523.754 510.669 523.754 510.669C523.754 510.669 562.069 538.658 630.165 525.345V525.345Z",
    fill: "#DC0D27"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M523.529 401.514C513.279 398.862 500.488 406.611 498.64 429.297C496.941 450.079 508.2 475.118 519.235 472.131C528.608 469.591 519.59 452.226 522.932 437.98C526.311 423.733 539.158 405.565 523.529 401.514V401.514Z",
    fill: "#FED3B0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M536.507 388.982C535.05 390.868 538.43 399.159 555.589 399.047C572.73 398.935 575.605 393.762 583.242 396.078C590.879 398.393 596.835 407.58 605.275 412.602C617.076 419.623 634.104 417.831 633.992 414.712C633.88 411.575 629.717 413.181 626.132 408.793C622.547 404.387 616.198 392.754 616.198 392.754C616.198 392.754 617.972 387.302 621.725 387.507C630.389 387.974 640.023 386.256 645.326 382.933C651.675 378.974 654.065 372.869 652.907 371.468C651.749 370.087 648.146 373.821 646.185 373.466C644.225 373.111 631.472 373.354 631.472 373.354L616.067 370.852C616.067 370.852 618.177 361.834 622.341 357.203C626.505 352.572 633.04 346.205 632.909 345.402C632.779 344.599 627.532 345.309 627.532 345.309L611.306 352.722L599.954 367.659L578.406 370.441L557.662 356.531C557.662 356.531 545.768 346.933 545.226 347.157C542.22 348.39 546.795 352.964 550.249 358.491C553.237 363.29 553.853 365.699 557.886 369.041C561.826 372.29 568.435 375.52 568.435 375.52L563.693 384.09C563.693 384.09 548.401 390.121 545.73 390.121C543.079 390.14 537.309 387.955 536.507 388.982V388.982Z",
    fill: "#BDCF44"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M584.382 383.812C590.637 384.279 595.156 392.588 600.795 398.245C609.029 406.48 615.471 410.774 622.398 412.399C625.871 413.202 633.844 414.527 633.844 414.527C633.844 414.527 635.002 413.724 631.062 411.521C627.122 409.318 624.751 405.098 624.172 403.137C623.593 401.177 621.782 394.735 617.973 389.395C614.164 384.055 609.832 381.795 611.214 379.368C612.595 376.941 624.545 381.049 636.047 379.2C651.227 376.773 653.543 371.899 652.852 371.32C652.161 370.742 642.769 373.524 638.026 372.478C633.284 371.433 629.213 368.184 622.043 368.184C617.151 368.184 612.371 369.957 611.083 367.287C610 365.047 614.07 357.559 617.17 354.74C624.695 347.906 632.817 346.282 632.817 345.348C632.817 343.425 619.616 342.342 610.467 349.642C601.355 356.906 603.073 366.447 591.235 366.447C587.295 366.447 585.783 365.514 585.783 365.514C585.783 365.514 580.498 361.163 573.44 357.335C566.382 353.508 561.061 355.207 556.99 353.246C552.939 351.286 545.75 346.207 545.059 347.234C544.368 348.261 550.455 355.207 558.111 360.883C565.766 366.559 574.337 369.453 571.891 371.769C569.463 374.084 565.411 375.596 561.584 378.49C557.756 381.385 554.395 385.548 549.764 387.061C545.134 388.573 537.516 387.509 536.47 388.779C535.424 390.048 544.536 394.436 558.783 391.785C572.992 389.133 573.03 382.972 584.382 383.812V383.812Z",
    fill: "#94A61D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M598.592 312.225C595.473 312.076 591.534 314.541 591.534 314.541C591.534 314.541 585.82 321.505 583.561 338.795C582.515 346.787 583.654 357.523 583.43 363.442C583.206 369.343 581.918 371.546 582.272 374.571C582.627 377.577 585.783 380.975 593.083 380.9C598.946 380.844 601.971 376.307 601.859 374.683C601.747 373.058 596.724 356.496 598.143 341.895C599.469 328.32 604.417 318.947 604.623 316.987C604.735 315.922 603.334 312.449 598.592 312.225V312.225Z",
    fill: "#728035"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M601.633 211.545C601.633 211.545 604.826 187.178 599.019 176.161C593.212 165.145 575.287 140.815 538.111 136.428C518.394 134.112 505.043 136.726 492.869 138.164C485.158 139.079 470.799 134.336 445.013 140.199C425.893 144.55 396.877 161.373 387.448 197.634C382.481 216.735 384.367 237.368 392.825 254.751C409.07 288.099 439.225 296.221 439.225 296.221L499.834 301.151L573.214 270.118L601.633 211.545V211.545Z",
    fill: "#FF2A23"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M531.165 304.345C569.741 296.801 603.089 262.296 608.896 225.755C614.329 191.567 594.351 168.656 594.351 168.656C594.351 168.656 596.629 186.899 592.371 206.336C587.797 227.137 574.558 261.81 532.621 281.453C481.143 305.558 424.754 289.669 424.754 289.669C424.754 289.669 463.069 317.658 531.165 304.345V304.345Z",
    fill: "#DC0D27"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M424.529 180.514C414.279 177.862 401.488 185.611 399.64 208.297C397.941 229.079 409.2 254.118 420.235 251.131C429.608 248.591 420.59 231.226 423.932 216.98C427.311 202.733 440.158 184.565 424.529 180.514V180.514Z",
    fill: "#FED3B0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M437.507 167.982C436.05 169.868 439.43 178.159 456.589 178.047C473.73 177.935 476.605 172.762 484.242 175.078C491.879 177.393 497.835 186.58 506.275 191.602C518.076 198.623 535.104 196.831 534.992 193.712C534.88 190.575 530.717 192.181 527.132 187.793C523.547 183.387 517.198 171.754 517.198 171.754C517.198 171.754 518.972 166.302 522.725 166.507C531.389 166.974 541.023 165.256 546.326 161.933C552.675 157.974 555.065 151.869 553.907 150.468C552.749 149.087 549.146 152.821 547.185 152.466C545.225 152.111 532.472 152.354 532.472 152.354L517.067 149.852C517.067 149.852 519.177 140.834 523.341 136.203C527.505 131.572 534.04 125.205 533.909 124.402C533.779 123.599 528.532 124.309 528.532 124.309L512.306 131.722L500.954 146.659L479.406 149.441L458.662 135.531C458.662 135.531 446.768 125.933 446.226 126.157C443.22 127.39 447.795 131.964 451.249 137.491C454.237 142.29 454.853 144.699 458.886 148.041C462.826 151.29 469.435 154.52 469.435 154.52L464.693 163.09C464.693 163.09 449.401 169.121 446.73 169.121C444.079 169.14 438.309 166.955 437.507 167.982V167.982Z",
    fill: "#BDCF44"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M485.382 162.812C491.637 163.279 496.156 171.588 501.795 177.245C510.029 185.48 516.471 189.774 523.398 191.399C526.871 192.202 534.844 193.527 534.844 193.527C534.844 193.527 536.002 192.724 532.062 190.521C528.122 188.318 525.751 184.098 525.172 182.137C524.593 180.177 522.782 173.735 518.973 168.395C515.164 163.055 510.832 160.795 512.214 158.368C513.595 155.941 525.545 160.049 537.047 158.2C552.227 155.773 554.543 150.899 553.852 150.32C553.161 149.742 543.769 152.524 539.026 151.478C534.284 150.433 530.213 147.184 523.043 147.184C518.151 147.184 513.371 148.957 512.083 146.287C511 144.047 515.07 136.559 518.17 133.74C525.695 126.906 533.817 125.282 533.817 124.348C533.817 122.425 520.616 121.342 511.467 128.642C502.355 135.906 504.073 145.447 492.235 145.447C488.295 145.447 486.783 144.514 486.783 144.514C486.783 144.514 481.498 140.163 474.44 136.335C467.382 132.508 462.061 134.207 457.99 132.246C453.939 130.286 446.75 125.207 446.059 126.234C445.368 127.261 451.455 134.207 459.111 139.883C466.766 145.559 475.337 148.453 472.891 150.769C470.463 153.084 466.411 154.596 462.584 157.49C458.756 160.385 455.395 164.548 450.764 166.061C446.134 167.573 438.516 166.509 437.47 167.779C436.424 169.048 445.536 173.436 459.783 170.785C473.992 168.133 474.03 161.972 485.382 162.812V162.812Z",
    fill: "#94A61D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M499.592 91.2253C496.473 91.0759 492.534 93.5406 492.534 93.5406C492.534 93.5406 486.82 100.505 484.561 117.795C483.515 125.787 484.654 136.523 484.43 142.442C484.206 148.343 482.918 150.546 483.272 153.571C483.627 156.577 486.783 159.975 494.083 159.9C499.946 159.844 502.971 155.307 502.859 153.683C502.747 152.058 497.724 135.496 499.143 120.895C500.469 107.32 505.417 97.9471 505.623 95.9866C505.735 94.9223 504.334 91.4493 499.592 91.2253V91.2253Z",
    fill: "#728035"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1280_10456",
    x: 793.801,
    y: 584.543,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1280_10456",
    x: 0.0253906,
    y: 233.859,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1280_10456",
    x: 94.6543,
    y: 463.199,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1280_10456",
    x: 208.209,
    y: 60.1875,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1280_10456",
    x: 959.682,
    y: 346.301,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1280_10456",
    x: 793.801,
    y: 155.93,
    width: 35.7188,
    height: 45.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.731667 0 0 0 0 0.329167 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1280_10456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1280_10456",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTomatoStarBurst);
export default __webpack_public_path__ + "static/media/big-tomato-star-burst.480117b96a10a49789baf6c6a7cbcc1a.svg";
export { ForwardRef as ReactComponent };